<template>
  <v-card
    :height="small ? '46' : '100'"
    :class="[
      'd-flex',
      'align-center',
      'justify-center',
      'rounded-lg',
      current ? 'v-current' : next ? 'v-next' : 'v-normal',
    ]"
    elevation="0"
    style="border: 4px solid #8ab7e9"
  >
    <p class="bold-h3 pb-2" style="color: #f5f5f9">
      {{ locker }}
    </p>
  </v-card>
</template>
<script>
export default {
  props: {
    locker: {
      type: String,
      required: true,
    },
    lockers: {
      type: Array,
    },
    lowestLockers: {
      type: Array,
      default: [],
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    current() {
      return this.lowestLockers.includes(this.locker);
    },
    next() {
      return this.lockers.includes(this.locker);
    },
  },
};
</script>
<style scoped>
.v-normal {
  background-color: #003a70;
}

.v-current {
  animation: blink 1s infinite alternate;
}

.v-next {
  background-color: #4caf50;
}

@keyframes blink {
  from {
    background-color: #003a70; /* Red */
  }
  to {
    background-color: #4caf50; /* Green */
  }
}

@keyframes next {
  from {
    background-color: #003a70; /* Red */
  }
  to {
    background-color: #fb8c00; /* Green */
  }
}
</style>
